import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  activeCircleStyle: theme => ({
    backgroundColor: theme.colors.tintColor,
  }),
  activeContainerStyle: theme => ({
    backgroundColor: theme.colors.activeColorThree,
    borderWidth: 0,
  }),
  averageCircleStyle: {
    borderRadius: 11,
    height: 20,
    width: 20,
  },
  averageContainerStyle: {
    borderRadius: 40,
    height: 24,
    width: 40,
  },
  inactiveCircleStyle: theme => ({
    backgroundColor: theme.colors.activeColorTwo,
    marginHorizontal: 2,
  }),
  inactiveContainerStyle: theme => ({
    backgroundColor: theme.colors.toggleBackgroundColor,
    justifyContent: 'center',
    margin: 5,
    paddingHorizontal: 1,
    borderWidth: theme.isDark ? 1 : null,
    borderColor: theme.isDark ? theme.colors.toggleBorderColor : null,
  }),
  shadowStyle: theme => ({
    elevation: 2,
    shadowColor: theme.colors.shadowColor,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 1,
    shadowRadius: 2,
  }),
  smallCircleStyle: {
    borderRadius: 8,
    height: 16,
    width: 16,
  },
  smallContainerStyle: {
    borderRadius: 40,
    height: 20,
    width: 28,
  },
});
